<template>
  <div class="container-fluid p-0 m-0">
    <section class="s-breadcrumb">
      <div class="row">
        <div class="col-12">
          <cHeader :headerdata="dataheader"></cHeader>
        </div>
      </div>
    </section>
    <section class="s-body">
      <div class="row">
        <div class="col-12 pb-4">
          <div class="row">
            <div class="col-12">
              <b-card no-body class="mb-3 card-collapse-custom">
                <b-card-header
                  header-tag="header"
                  :class="Section1_card ? null : 'collapsed'"
                  :aria-expanded="Section1_card ? 'true' : 'false'"
                  aria-controls="Section1_card"
                  @click="Section1_card = !Section1_card"
                >
                  <div class="d-flex bd-highlight text-start">
                    <div class="m-0 w-100 bd-highlight">
                      <h3 class="my-2 pl-4">ส่วนที่ 1 : การขออนุญาตทำงาน</h3>
                    </div>
                    <div class="flex-shrink-1 bd-highlight">
                      <i
                        class="fas pr-4 my-2"
                        :class="Section1_card ? 'fa-angle-up' : 'fa-angle-down'"
                      ></i>
                    </div>
                  </div>
                </b-card-header>
                <b-collapse id="Section1_card" v-model="Section1_card">
                  <b-card-body>
                    <div class="row">
                      <div class="col-12 col-lg-6">
                        <cInputSelect
                          :title="''"
                          :label="'ชื่อผู้ขออนุญาต (Permit Requester)'"
                          v-model="form[field.RequesterName]"
                          :req="false"
                          :disable="true"
                        ></cInputSelect>
                      </div>
                      <div class="col-12 col-lg-6">
                        <cInputSelect
                          :title="''"
                          :label="'สังกัดหน่วยงาน'"
                          v-model="form[field.Department]"
                          :req="false"
                          :disable="true"
                        ></cInputSelect>
                      </div>
                      <div class="col-12 col-lg-6">
                        <cInputSelect
                          :title="''"
                          :label="'ทำงานในเขตพื้นที่'"
                          v-model="form[field.WorkDistrict]"
                          :req="false"
                          :disable="true"
                        ></cInputSelect>
                      </div>
                      <div class="col-12 col-lg-6">
                        <cInputSelect
                          :title="''"
                          :label="'สถานที่/อุปกรณ์'"
                          v-model="form[field.WorkplaceAndEquipment]"
                          :req="false"
                          :disable="true"
                        ></cInputSelect>
                      </div>
                      <div class="col-12 col-lg-6">
                        <cInputSelect
                          :title="''"
                          :label="'ตำแหน่งที่ต้องขุด'"
                          v-model="form[field.MiningArea]"
                          :req="false"
                          :disable="true"
                        ></cInputSelect>
                      </div>
                      <div class="col-12 col-lg-6">
                        <cInputSelect
                          :title="''"
                          :label="'เหตุผลที่ต้องทำงานขุดเนื่องจาก'"
                          v-model="form[field.MiningReason]"
                          :req="false"
                          :disable="true"
                        ></cInputSelect>
                      </div>
                      <div class="col-12 col-lg-6">
                        <cInputSelect
                          :title="''"
                          :label="'อุปกรณ์ที่ใช้ขุด'"
                          v-model="form[field.MiningEquipment]"
                          :req="false"
                          :disable="true"
                        ></cInputSelect>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label for="">ขุดหลุมลึก :</label>
                          <div class="row align-items-center px-3">
                            <div class="form-check form-check-block">
                              <input
                                type="radio"
                                class="form-check-input"
                                name="radio-MiningDept"
                                id="radio-MiningDept1"
                                value="1"
                                v-model="form[field.MiningDept]"
                                :disabled="true"
                              />
                              <label
                                class="form-check-label"
                                for="radio-MiningDept1"
                                >งานขุดตั้งแต่ 30 cm - 1.2 m.</label
                              >
                            </div>
                            <div class="form-check form-check-block">
                              <input
                                type="radio"
                                class="form-check-input"
                                name="radio-MiningDept"
                                id="radio-MiningDept2"
                                value="2"
                                v-model="form[field.MiningDept]"
                                :disabled="true"
                              />
                              <label
                                class="form-check-label"
                                for="radio-MiningDept2"
                                >งานขุดตั้งแต่ 1.2 m. - 2.0 m.</label
                              >
                            </div>
                            <div class="form-check form-check-block">
                              <input
                                type="radio"
                                class="form-check-input"
                                name="radio-MiningDept"
                                id="radio-MiningDept3"
                                value="3"
                                v-model="form[field.MiningDept]"
                                :disabled="true"
                              />
                              <label
                                class="form-check-label"
                                for="radio-MiningDept3"
                                >งานขุดตั้งแต่ 2 m. ขึ้นไป</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-6">
                        <div class="form-group">
                          <label class="" for="radio-MiningDept4"
                            >พื้นที่กว้าง x ยาว</label
                          >
                          <input
                            type="number"
                            class="form-control"
                            for="radio-MiningDept4"
                            :disabled="true"
                          />
                          <span class="text-suffix">m<sup>2</sup></span>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="row">
                          <div class="col-12 col-lg-6 pb-0">
                            <cDateTime
                              :title="'MiningStartDate'"
                              :type="'date'"
                              v-model="form[field.MiningStartDate]"
                              :req="false"
                              :label="'เริ่มขุดวันที่'"
                              :disable="true"
                            ></cDateTime>
                          </div>
                          <div class="col-12 col-lg-6 pb-0">
                            <cDateTime
                              :type="'time'"
                              :title="'MiningStartTime'"
                              :label="'เวลา'"
                              :req="false"
                              :disable="true"
                              v-model="form[field.MiningStartTime]"
                            ></cDateTime>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="row">
                          <div class="col-12 col-lg-6 pb-0">
                            <cDateTime
                              :title="'MiningEndDate'"
                              :type="'date'"
                              v-model="form[field.MiningEndDate]"
                              :req="false"
                              :label="'สิ้นสุดงานขุดวันที่'"
                              :disable="true"
                            ></cDateTime>
                          </div>
                          <div class="col-12 col-lg-6 pb-0">
                            <cDateTime
                              :type="'time'"
                              :title="'MiningEndTime'"
                              :label="'เวลา'"
                              :req="false"
                              :disable="true"
                              v-model="form[field.MiningEndTime]"
                            ></cDateTime>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <cInputSelect
                          :title="''"
                          :label="'EE ที่ทำการอนุมัติ'"
                          v-model="form[field.ApprovedEE]"
                          :req="false"
                          :disable="true"
                        ></cInputSelect>
                      </div>
                      <div class="col-12 col-lg-6">
                        <cInputSelect
                          :title="''"
                          :label="'ME ที่ทำการอนุมัติ'"
                          v-model="form[field.ApprovedME]"
                          :req="false"
                          :disable="true"
                        ></cInputSelect>
                      </div>
                      <div class="col-12 py-2">
                        <label for="" class=""
                          >เอกสารประกอบการขออนุญาตทำงาน (สำหรับงานขุดตั้งแต่ 2
                          เมตรขึ้นไป)</label
                        >
                      </div>
                      <div class="col-12 mb-2">
                        <div class="row">
                          <div class="col-12">
                            <label for=""
                              >1. แผนช่วยเหลือฉุกเฉิน (Rescue Plan)</label
                            >
                          </div>
                          <div class="col-12">
                            <b-button-group
                              class="col-12 px-1 pb-1"
                              v-for="(itemFile, indexFile) in form.Listfiles1"
                              :key="indexFile"
                            >
                              <b-button
                                variant="light"
                                class="
                                  btn btn-light
                                  text-truncate
                                  w-100
                                  btn-fileuploads
                                "
                              >
                                <span @click="genData(itemFile)">{{
                                  itemFile.FileName
                                }}</span>
                              </b-button>
                            </b-button-group>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 mb-2">
                        <div class="row">
                          <div class="col-12">
                            <label for=""
                              >1.
                              เอกสารแสดงการคำนวณ/ออกแบบมาตรการป้องกันการเคลื่อนตัวของดินโดยวิศวกร</label
                            >
                          </div>
                          <div class="col-12">
                            <b-button-group
                              class="col-12 px-1 pb-1"
                              v-for="(itemFile, indexFile) in form.Listfiles2"
                              :key="indexFile"
                            >
                              <b-button
                                variant="light"
                                class="
                                  btn btn-light
                                  text-truncate
                                  w-100
                                  btn-fileuploads
                                "
                              >
                                <span @click="genData(itemFile)">{{
                                  itemFile.FileName
                                }}</span>
                              </b-button>
                            </b-button-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <div class="col-12">
              <b-card no-body class="mb-3 card-collapse-custom">
                <b-card-header
                  header-tag="header"
                  :class="Section2_card ? null : 'collapsed'"
                  :aria-expanded="Section2_card ? 'true' : 'false'"
                  aria-controls="Section2_card"
                  @click="Section2_card = !Section2_card"
                >
                  <div class="d-flex bd-highlight text-start">
                    <div class="m-0 w-100 bd-highlight">
                      <h3 class="my-2 pl-4">
                        ส่วนที่ 2 : ตรวจสอบก่อนเริ่มปฏิบัตงาน (ที่หน้างาน)
                      </h3>
                    </div>
                    <div class="flex-shrink-1 bd-highlight">
                      <i
                        class="fas pr-4 my-2"
                        :class="Section2_card ? 'fa-angle-up' : 'fa-angle-down'"
                      ></i>
                    </div>
                  </div>
                </b-card-header>
                <b-collapse id="Section2_card" v-model="Section2_card">
                  <b-card-body>
                    <div class="row">
                      <div class="col-12">
                        <h3 class="back-color">
                          2.1
                          การตรวจสอบโดยผู้ตรวจสอบที่เกี่ยวข้องกับระบบไฟฟ้าใต้ดิน
                          (EE)
                        </h3>
                      </div>
                      <div class="col-12 my-2">
                        <label for=""
                          >(1) สายไฟใต้ดิน (กรณีไม่มีระบบสายไฟใต้ดิน
                          ไม่ต้องดำเนินการต่อในข้อ 2.1 (2))</label
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_EEitem-1`"
                            :id="`radio_EEitem-1-pass`"
                            value="1"
                            v-model="form[field.isUndergroundLine]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_EEitem-1`"
                            :for="`radio_EEitem-1-pass`"
                            >มี</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_EEitem-1`"
                            :id="`radio_EEitem-1-notPass`"
                            value="0"
                            v-model="form[field.isUndergroundLine]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_EEitem-1`"
                            :for="`radio_EEitem-1-notPass`"
                            >ไม่มี</label
                          >
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <label for=""
                          >(2) กรณีสายไฟใต้ดินต้องแนบแบบ Underground ของ System
                          ที่เกี่ยวข้องดังต่อไปนี้</label
                        >
                      </div>
                      <div class="col-12 my-2">
                        <label for="">
                          1. Grounding System Layout & Cathodic Protection
                          (Underground)</label
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_EEitem-2`"
                            :id="`radio_EEitem-2-pass`"
                            value="1"
                            v-model="form[field.isGroundingSystem]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_EEitem-2`"
                            :for="`radio_EEitem-2-pass`"
                            >มี</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_EEitem-2`"
                            :id="`radio_EEitem-2-notPass`"
                            value="0"
                            v-model="form[field.isGroundingSystem]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_EEitem-2`"
                            :for="`radio_EEitem-2-notPass`"
                            >ไม่มี</label
                          >
                        </div>
                        <div class="">
                          <b-button-group
                            class="col-12 px-1 pb-1"
                            v-for="(itemFile, indexFile) in form.Listfiles1_EE"
                            :key="indexFile"
                          >
                            <b-button
                              variant="light"
                              class="
                                btn btn-light
                                text-truncate
                                w-100
                                btn-fileuploads
                              "
                            >
                              <span @click="genData(itemFile)">{{
                                itemFile.FileName
                              }}</span>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                      <div class="col-12 my-2">
                        <label for="">
                          2. Lighting System Layout (Underground)</label
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_EEitem-3`"
                            :id="`radio_EEitem-3-pass`"
                            value="1"
                            v-model="form[field.isLightingSystem]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_EEitem-3`"
                            :for="`radio_EEitem-3-pass`"
                            >มี</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_EEitem-3`"
                            :id="`radio_EEitem-3-notPass`"
                            value="0"
                            v-model="form[field.isLightingSystem]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_EEitem-3`"
                            :for="`radio_EEitem-3-notPass`"
                            >ไม่มี</label
                          >
                        </div>
                        <div class="">
                          <b-button-group
                            class="col-12 px-1 pb-1"
                            v-for="(itemFile, indexFile) in form.Listfiles2_EE"
                            :key="indexFile"
                          >
                            <b-button
                              variant="light"
                              class="
                                btn btn-light
                                text-truncate
                                w-100
                                btn-fileuploads
                              "
                            >
                              <span @click="genData(itemFile)">{{
                                itemFile.FileName
                              }}</span>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                      <div class="col-12 my-2">
                        <label for="">
                          3. Network and communication layout เช่น Lan,
                          โทรศัพท์, Paging</label
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_EEitem-4`"
                            :id="`radio_EEitem-4-pass`"
                            value="1"
                            v-model="form[field.isNetworkSystem]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_EEitem-4`"
                            :for="`radio_EEitem-4-pass`"
                            >มี</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_EEitem-4`"
                            :id="`radio_EEitem-4-notPass`"
                            value="0"
                            v-model="form[field.isNetworkSystem]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_EEitem-4`"
                            :for="`radio_EEitem-4-notPass`"
                            >ไม่มี</label
                          >
                        </div>
                        <div class="">
                          <b-button-group
                            class="col-12 px-1 pb-1"
                            v-for="(itemFile, indexFile) in form.Listfiles3_EE"
                            :key="indexFile"
                          >
                            <b-button
                              variant="light"
                              class="
                                btn btn-light
                                text-truncate
                                w-100
                                btn-fileuploads
                              "
                            >
                              <span @click="genData(itemFile)">{{
                                itemFile.FileName
                              }}</span>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                      <div class="col-12 mb-3">
                        <div class="row">
                          <div class="col-12">
                            <label for="">ลงชื่อ</label>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <input
                                class="form-control"
                                value="วศ.ไฟฟ้า (EE) หรือเทียบเท่า"
                                disabled
                              />
                            </div>
                          </div>
                          <div class="col-12">
                            <cInputSelect
                              :title="''"
                              :label="'ผู้ลงชื่อ'"
                              :value="form[field.ApprovedEEName]"
                              :req="false"
                              :disable="true"
                            ></cInputSelect>
                          </div>
                          <div class="col-12">
                            <cInputSelect
                              :title="''"
                              :label="'วันที่และเวลา'"
                              :value="form.EEDateTime"
                              :req="false"
                              :disable="true"
                            ></cInputSelect>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label for="">ข้อเสนอแนะ</label>
                              <textarea
                                class="form-control"
                                :class="{
                                  'text-danger':
                                    form[field.isEEApproved] == '0' &&
                                    form[field.Status] == '3',
                                }"
                                :value="form[field.EEComment]"
                                rows="3"
                                readonly
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="underline"></div>
                      </div>

                      <div class="col-12">
                        <h3 class="back-color">
                          2.1
                          การตรวจสอบโดยผู้ตรวจสอบที่เกี่ยวข้องกับระบบท่อใต้ดิน
                          (ME)
                        </h3>
                      </div>
                      <div class="col-12 my-2">
                        <label for=""
                          >(1) ท่อน้ำใต้ดิน/ท่อน้ำดับเพลิง หรือท่ออื่นๆ
                          (กรณีไม่มี ไม่ต้องดำเนินการต่อในข้อ 2.2 (2))</label
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-1`"
                            :id="`radio_MEitem-1-pass`"
                            value="1"
                            v-model="form[field.isUndergroundPipe]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-1`"
                            :for="`radio_MEitem-1-pass`"
                            >มี</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-1`"
                            :id="`radio_MEitem-1-notPass`"
                            value="0"
                            v-model="form[field.isUndergroundPipe]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-1`"
                            :for="`radio_MEitem-1-notPass`"
                            >ไม่มี</label
                          >
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <label for=""
                          >(2) กรณีมีระบบท่อใต้ดินต้องแนบแบบ Underground ของ
                          System ที่เกี่ยวข้องดังต่อไปนี้</label
                        >
                      </div>
                      <div class="col-12 my-2">
                        <label for="">
                          1. Piping Arrangement Dwg.For underground
                          piping</label
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-2`"
                            :id="`radio_MEitem-2-pass`"
                            value="1"
                            v-model="form[field.isPipingArrangement]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-2`"
                            :for="`radio_MEitem-2-pass`"
                            >มี</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-2`"
                            :id="`radio_MEitem-2-notPass`"
                            value="0"
                            v-model="form[field.isPipingArrangement]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-2`"
                            :for="`radio_MEitem-2-notPass`"
                            >ไม่มี</label
                          >
                        </div>
                        <div class="">
                          <b-button-group
                            class="col-12 px-1 pb-1"
                            v-for="(itemFile, indexFile) in form.Listfiles1_ME"
                            :key="indexFile"
                          >
                            <b-button
                              variant="light"
                              class="
                                btn btn-light
                                text-truncate
                                w-100
                                btn-fileuploads
                              "
                            >
                              <span @click="genData(itemFile)">{{
                                itemFile.FileName
                              }}</span>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                      <div class="col-12 my-2">
                        <label for="">
                          2. Fire water : Underground / Ring loop main
                          layout</label
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-3`"
                            :id="`radio_MEitem-3-pass`"
                            value="1"
                            v-model="form[field.isFireWater]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-3`"
                            :for="`radio_MEitem-3-pass`"
                            >มี</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-3`"
                            :id="`radio_MEitem-3-notPass`"
                            value="0"
                            v-model="form[field.isFireWater]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-3`"
                            :for="`radio_MEitem-3-notPass`"
                            >ไม่มี</label
                          >
                        </div>
                        <div class="">
                          <b-button-group
                            class="col-12 px-1 pb-1"
                            v-for="(itemFile, indexFile) in form.Listfiles2_ME"
                            :key="indexFile"
                          >
                            <b-button
                              variant="light"
                              class="
                                btn btn-light
                                text-truncate
                                w-100
                                btn-fileuploads
                              "
                            >
                              <span @click="genData(itemFile)">{{
                                itemFile.FileName
                              }}</span>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                      <div class="col-12 my-2">
                        <label for="">
                          3. P&amp;ID F/W, Underground piping</label
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-4`"
                            :id="`radio_MEitem-4-pass`"
                            value="1"
                            v-model="form[field.isPidOrFw]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-4`"
                            :for="`radio_MEitem-4-pass`"
                            >มี</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-4`"
                            :id="`radio_MEitem-4-notPass`"
                            value="0"
                            v-model="form[field.isPidOrFw]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-4`"
                            :for="`radio_MEitem-4-notPass`"
                            >ไม่มี</label
                          >
                        </div>
                        <div class="">
                          <b-button-group
                            class="col-12 px-1 pb-1"
                            v-for="(itemFile, indexFile) in form.Listfiles3_ME"
                            :key="indexFile"
                          >
                            <b-button
                              variant="light"
                              class="
                                btn btn-light
                                text-truncate
                                w-100
                                btn-fileuploads
                              "
                            >
                              <span @click="genData(itemFile)">{{
                                itemFile.FileName
                              }}</span>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                      <div class="col-12 my-2">
                        <label for=""
                          >(3)
                          เมื่อทำงานใกล้กับสิ่งก่อสรา้งได้มีการตรวจสอบและแนบรายละเอียดแบบก่อสร้างและผลกระทบที่อาจเกิดขึ้น</label
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-5`"
                            :id="`radio_MEitem-5-pass`"
                            value="1"
                            v-model="form[field.isNearContructionCheck]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-5`"
                            :for="`radio_MEitem-5-pass`"
                            >มี</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="`CheckList_MEitem-5`"
                            :id="`radio_MEitem-5-notPass`"
                            value="0"
                            v-model="form[field.isNearContructionCheck]"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :name="`CheckList_MEitem-5`"
                            :for="`radio_MEitem-5-notPass`"
                            >ไม่มี</label
                          >
                        </div>
                        <div class="">
                          <b-button-group
                            class="col-12 px-1 pb-1"
                            v-for="(itemFile, indexFile) in form.Listfiles4_ME"
                            :key="indexFile"
                          >
                            <b-button
                              variant="light"
                              class="
                                btn btn-light
                                text-truncate
                                w-100
                                btn-fileuploads
                              "
                            >
                              <span @click="genData(itemFile)">{{
                                itemFile.FileName
                              }}</span>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                      <div class="col-12 mb-3">
                        <div class="row">
                          <div class="col-12">
                            <label for="">ลงชื่อ</label>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <input
                                class="form-control"
                                value="วศ.เครื่องกล (ME) หรือเทียบเท่า"
                                disabled
                              />
                            </div>
                          </div>
                          <div class="col-12">
                            <cInputSelect
                              :title="''"
                              :label="'ผู้ลงชื่อ'"
                              :value="form[field.ApprovedMEName]"
                              :req="false"
                              :disable="true"
                            ></cInputSelect>
                          </div>
                          <div class="col-12">
                            <cInputSelect
                              :title="''"
                              :label="'วันที่และเวลา'"
                              :value="form.MEDateTime"
                              :req="false"
                              :disable="true"
                            ></cInputSelect>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label for="">ข้อเสนอแนะ</label>
                              <textarea
                                class="form-control"
                                :class="{
                                  'text-danger':
                                    form[field.isMEApproved] == '0' &&
                                    form[field.Status] == '3',
                                }"
                                :value="form[field.MEComment]"
                                rows="3"
                                readonly
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="underline"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <h3 class="back-color">
                          2.3 มาตรการความปลอดภัยที่ต้องปฏิบัติ
                          (ตรวจสอบเจ้าของพื้นที่ ทุก 7 วัน)
                        </h3>
                      </div>
                      <div
                        class="col-12 my-2"
                        v-for="(item, index) in Section2_Table"
                        :key="index"
                      >
                        <div v-if="index !== 0 && index !== 15 && index !== 19">
                          <label for="">{{ item.ChecklistName }}</label>
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              :name="`CheckList_item-${index}`"
                              :id="`radio_item-${index}-pass`"
                              value="1"
                              v-model="Section2_Table[index].Checklist"
                              :disabled="!permissionAction"
                            />
                            <label
                              class="form-check-label"
                              :name="`CheckList_item-${index}`"
                              :for="`radio_item-${index}-pass`"
                              >ผ่าน</label
                            >
                          </div>
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              :name="`CheckList_item-${index}`"
                              :id="`radio_item-${index}-notPass`"
                              value="2"
                              v-model="Section2_Table[index].Checklist"
                              :disabled="!permissionAction"
                            />
                            <label
                              class="form-check-label"
                              :name="`CheckList_item-${index}`"
                              :for="`radio_item-${index}-notPass`"
                              >ไม่ผ่าน</label
                            >
                          </div>
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              :name="`CheckList_item-${index}`"
                              :id="`radio_item-${index}-notInvoled`"
                              value="3"
                              v-model="Section2_Table[index].Checklist"
                              :disabled="!permissionAction"
                            />
                            <label
                              class="form-check-label"
                              :name="`CheckList_item-${index}`"
                              :for="`radio_item-${index}-notInvoled`"
                              >ไม่เกี่ยวข้อง</label
                            >
                          </div>
                          <div class="form-group">
                            <textarea
                              :name="`CheckList_item-${index}`"
                              :for="`input_item-${index}`"
                              v-model="Section2_Table[index].Comment"
                              :disabled="!permissionAction"
                              rows="2"
                              class="form-control"
                            ></textarea>
                          </div>
                        </div>
                        <div
                          v-else-if="index == 0 || index == 15 || index == 19"
                        >
                          <label for="">{{ item.ChecklistName }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-5">
                            <label for="">Deviation</label>
                          </div>
                          <div class="col-7 text-right">
                            <button
                              class="btn custom text-warning p-0"
                              @click="onClickAddDeviation"
                              :disabled="!permissionAction"
                            >
                              <i class="fas fa-plus-circle"></i> Add Deviation
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 mt-1">
                        <div class="table-responsive">
                          <table class="table table-custom">
                            <thead class="text-center">
                              <tr>
                                <th></th>
                                <th>Deviation Document</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, index) in deviationData"
                                :key="index"
                              >
                                <td colspan="3" class="">
                                  <div class="row text-left">
                                    <div class="col-12">
                                      <div class="row">
                                        <div class="col-6">
                                          <label :for="'checkTable' + index">
                                            <b>{{ item.DeviationNo }}</b>
                                          </label>
                                        </div>
                                        <div class="col-6">
                                          <div class="form-check text-right">
                                            <input
                                              class="form-check-input"
                                              type="checkbox"
                                              :id="'checkTable' + index"
                                              :checked="
                                                onModelDeviation_checked(
                                                  item.Id
                                                )
                                              "
                                              @change="
                                                onModelDeviation_select(item.Id)
                                              "
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <label class="col-12" for=""
                                      ><a class="text-secondary"
                                        >Device Tag :</a
                                      >
                                      {{ item.EquipmentName }}
                                    </label>
                                    <label class="col-12" for=""
                                      ><a class="text-secondary"
                                        >Type Request :</a
                                      >
                                      {{ item.DepartmentName }}
                                    </label>
                                    <label class="col-12" for=""
                                      ><a class="text-secondary"
                                        >Job Description :</a
                                      >
                                      {{ item.Description }}
                                    </label>
                                    <label class="col-12" for=""
                                      ><a class="text-secondary"
                                        >Start Date :</a
                                      >
                                      {{ item.ActualExemtionStartDate }}
                                      {{ item.ActualExemtionStartTime }} -
                                      {{ item.ActualExemtionEndDate }}
                                      {{ item.ActualExemtionEndTime }}
                                    </label>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <!-- <div class="col-12 pb-2">
                        <div class="d-flex justify-content-center">
                          <b-pagination
                            v-model="paging.PageNo"
                            :total-rows="paging.totalItem"
                            :per-page="paging.PageSize"
                            first-number
                            last-number
                            prev-class="prev"
                            next-class="next"
                            page-class="numpage"
                            class="custompaging"
                          >
                          </b-pagination>
                        </div>
                      </div> -->
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <div class="col-12 pb-2">
              <div class="m-0">
                <button
                  type="button"
                  class="
                    btn btn-darkblue
                    shadow-sm
                    custom
                    cus-size-approve
                    w-100
                    mb-2
                  "
                  v-show="permissionAction == true"
                  @click="onClickNext()"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    {{ mLanguage.next[setLanguage]
                    }}<i class="fas fa-chevron-right ml-2"></i>
                  </div>
                </button>
              </div>
            </div>

            <b-modal
              id="modal-AddDeviation"
              ref="modal-AddDeviation"
              size="lg"
              centered
              title="Add Deviation"
              hide-footer
              buttonSize="lg"
            >
              <div class="s-body">
                <div class="row">
                  <div class="col-12">
                    <cInputSelect
                      :title="'DeviationDoc'"
                      :label="'Deviation Document'"
                      v-model="modalDeviation.deviationDoc"
                      :req="false"
                      :disable="false"
                    ></cInputSelect>
                  </div>
                  <div class="col-12">
                    <cInputSelect
                      :title="'Area'"
                      :label="'Area'"
                      v-model="modalDeviation.area"
                      :req="false"
                      :disable="false"
                    ></cInputSelect>
                  </div>
                  <div class="col-12 mt-2">
                    <button
                      type="button"
                      class="btn btn-darkblue custom shadow-sm w-100 mb-3"
                      @click="onModelDeviation_search()"
                    >
                      <i class="fas fa-search"></i
                      ><span class="ml-2">{{
                        mLanguage.search[setLanguage]
                      }}</span>
                    </button>
                    <button
                      type="button"
                      class="btn btn-custom w-100 bg3-color m-0"
                      @click="onModelDeviation_clear"
                    >
                      <i class="fas fa-undo"></i
                      ><span class="ml-2">{{
                        mLanguage.clear[setLanguage]
                      }}</span>
                    </button>
                  </div>
                  <div class="col-12 mt-4">
                    <div class="table-responsive">
                      <table class="table table-custom">
                        <thead class="text-center">
                          <tr>
                            <th></th>
                            <th>Deviation Document</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in modalDeviation.datalistResult"
                            :key="index"
                          >
                            <td colspan="3" class="">
                              <div class="row text-left">
                                <div class="col-12">
                                  <div class="row">
                                    <div class="col-6">
                                      <label for="">
                                        <b>{{ item.DeviationNo }}</b>
                                      </label>
                                    </div>
                                    <div class="col-6">
                                      <div class="form-check text-right">
                                        <input
                                          class="form-check-input"
                                          type="checkbox"
                                          :id="'checkTable' + index"
                                          :checked="
                                            modalDeviation.selected.indexOf(
                                              item.Id
                                            ) !== -1
                                          "
                                          @change="
                                            onModelDeviationMain_select(item.Id)
                                          "
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <label class="col-12" for=""
                                  ><a class="text-secondary">Device Tag :</a>
                                  {{ item.EquipmentName }}
                                </label>
                                <label class="col-12" for=""
                                  ><a class="text-secondary">Type Request :</a>
                                  {{ item.Department }}
                                </label>
                                <label class="col-12" for=""
                                  ><a class="text-secondary"
                                    >Job Description :</a
                                  >
                                  {{ item.Description }}
                                </label>
                                <label class="col-12" for=""
                                  ><a class="text-secondary">Start Date :</a
                                  >{{ item.ActualExemtionStartDate }}
                                  {{ item.ActualExemtionStartTime }} -
                                  {{ item.ActualExemtionEndDate }}
                                  {{ item.ActualExemtionEndTime }}</label
                                >
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 pb-2">
                    <div class="d-flex justify-content-center">
                      <b-pagination
                        @change="onModelDeviation_ChangeCurrentPage"
                        v-model="modalDeviation.PageNo"
                        :total-rows="modalDeviation.totalItem"
                        :per-page="modalDeviation.PageSize"
                        first-number
                        last-number
                        prev-class="prev"
                        next-class="next"
                        page-class="numpage"
                        class="custompaging"
                      >
                      </b-pagination>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12" v-show="permissionAction == true">
                        <button
                          type="button"
                          class="btn btn-custom w-100 bg1-color text-white"
                          @click="onClickAdd_inputModal"
                        >
                          Add
                        </button>
                      </div>
                      <div class="col-12">
                        <button
                          type="button"
                          class="btn btn-custom w-100 bg3-color"
                          @click="onClickCancel_inputModal"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import Panel from "../plugins/panel/Panel.vue";
import mLanguage from "../config/MasterLanguage.vue";
import cUploadFile from "../components/custom-component/input-custom-files.vue";
import cInputSelect from "../components/custom-component/input-custom.vue";
import cTime from "../components/custom-component/input-custom-time.vue";
import Apimaster from "../service/Master";
import Apiservice from "../service/Service";
import cDateTime from "../components/custom-component/input-custom-datetime.vue";
import HelpFunc from "../Helper/funcHelper";
import cHeader from "../components/custom-component/breadcrumb-custom.vue"
import checkCompanyAPI from "../Helper/checkCompanyForMobile"

const $f = {
  Id: "Id",
  Code: "Code",
  DocumentCode: "DocumentCode",
  DocumentNumber: "DocumentNumber",
  EffectDate: "EffectDate",
  RequesterEmpId: "RequesterEmpId",
  RequesterName: "RequesterName",
  Department: "Department",
  WorkDistrict: "WorkDistrict",
  WorkplaceAndEquipment: "WorkplaceAndEquipment",
  MiningArea: "MiningArea",
  MiningReason: "MiningReason",
  MiningEquipment: "MiningEquipment",
  MiningDept: "MiningDept",
  MiningDeptValue: "MiningDeptValue",
  MiningStartDate: "MiningStartDate",
  MiningStartTime: "MiningStartTime",
  MiningEndDate: "MiningEndDate",
  MiningEndTime: "MiningEndTime",
  ApprovedEE: "ApprovedEE",
  EEEmpId: "EEEmpId",
  ApprovedEEName: "ApprovedEEName",
  ApprovedME: "ApprovedME",
  MEEmpId: "MEEmpId",
  ApprovedMEName: "ApprovedMEName",
  isUndergroundLine: "isUndergroundLine",
  UndergroundLine: "UndergroundLine",
  isUndergroundLineDocument: "isUndergroundLineDocument",
  UndergroundLineDocument: "UndergroundLineDocument",
  isGroundingSystem: "isGroundingSystem",
  isLightingSystem: "isLightingSystem",
  isNetworkSystem: "isNetworkSystem",
  isEEApproved: "isEEApproved",
  EEApprovedDateTime: "EEApprovedDateTime",
  EEApprovedDate: "EEApprovedDate",
  EEApprovedTime: "EEApprovedTime",
  EEComment: "EEComment",
  isUndergroundPipe: "isUndergroundPipe",
  UndergroundPipe: "UndergroundPipe",
  isUndergroundPipeDocument: "isUndergroundPipeDocument",
  UndergroundPipeDocument: "UndergroundPipeDocument",
  isPipingArrangement: "isPipingArrangement",
  isFireWater: "isFireWater",
  isPidOrFw: "isPidOrFw",
  isNearContructionCheck: "isNearContructionCheck",
  isMEApproved: "isMEApproved",
  MEApprovedDateTime: "MEApprovedDateTime",
  MEApprovedDate: "MEApprovedDate",
  MEApprovedTime: "MEApprovedTime",
  MEComment: "MEComment",
  Step: "Step",
  Status: "Status",
  StatusName: "StatusName",
  CreateBy: "CreateBy",
  CreateDateTime: "CreateDateTime",
  UpdateBy: "UpdateBy",
  UpdateDateTime: "UpdateDateTime",
  DelFlag: "DelFlag",
  totalrow: "totalrow",
};

export default {
  components: {
    Panel,
    cUploadFile,
    cInputSelect,
    cTime,
    cDateTime,
    cHeader
  },
  data() {
    return {
      mLanguage: mLanguage,
      typeUploadfiles: [
        "png",
        "svg",
        "jpg",
        "pdf",
        "doc",
        "docx",
        "docm",
        "csv",
        "xls",
        "xlsm",
        "xlsx",
        "ppt",
        "pptm",
        "pptx",
      ],
      field: $f,
			dataheader: {
        header: 'Section 3 : Preview',
        homelink: '',
				print: false,
        breadcrumb: [
          {
            title: "Work Permit Create",
            path: "",
          },
          {
            title: "Section 3 : SWP Checklist",
            path: "",
          }
        ]
      },
      permissionAction: "",
      paging: {
        PageSize: 3, //per page size of table
        PageNo: 1, // page number of table
        totalItem: 0,
        Size: [10, 20, 50, 100], // type per page size
      },
      Section1_card: true,
      Section2_card: true,
      Section3_card: true,
      Section2_Table: [
        { ChecklistName: "2.3.1 มาตรการความปลอดภัยขั้นพื้นฐาน" },
        {
          Id: "",
          ChkId: "1",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "1. เมื่อทำงานใกล้กับอุปกรณ์ที่มีความเสี่ยงต่อการรั่วไหลของสารไวไฟ สารเคมีอันตราย หรือสารไฮโดรคาร์บอนในดิน ได้มีการวัดแก๊สไวไฟ สารเคมีอันตราย ปริมาณออกซิเจน เรียบร้อยเเล้ว",
        },
        {
          Id: "",
          ChkId: "2",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "2. พื้นที่ตาน้ำ ต้องระบุขั้นตอนการตรวจสอบน้ำและจัดให้มีปั้มดูดน้ำออก",
        },
        {
          Id: "",
          ChkId: "3",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "3. กรณีสายไฟ ท่อน้ำดับเพลิงใต้ดินห้ามใช้เครื่องจักขุด ในระยะรัศมี 1 เมตร",
        },
        {
          Id: "",
          ChkId: "4",
          Checklist: "",
          Comment: "",
          ChecklistName:
            '4. "กรณีมีสายไฟใต้ดินได้มีการตัดเเยกพลังงาน (LOTO & Line break) ที่เกี่ยวข้องเรียบร้อยเเล้ว กรณีที่ไม่สามารถตัดแหล่งจ่ายไฟฟ้าได้ต้องมีช่างไฟฟ้าคอยควบคุมตลอดเวลาขณะทำงาน"',
        },
        {
          Id: "",
          ChkId: "5",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "5. การปิดกั้นด้วย Hard barricade ห่างจากขอบบ่อ หลุม ช่องเปิด อย่างน้อย 1 เมตร หรือต้องจัดให้มีแผ่นโลหะหรือวัสดุที่มีความแข็งแรงปิดคลุม",
        },
        {
          Id: "",
          ChkId: "6",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "6. ห้ามเครื่องจักรใหญ่ทำงานปากหลุม, บ่อ ขณะที่มีคนทำงานภายในหลุม, บ่อ",
        },
        {
          Id: "",
          ChkId: "7",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "7. ดินที่ขุดออกจากหลุม ต้องวางห่างจากขอบไม่น้อยกว่า 1 เมตร และไม่กีดขวางทางเดิน พื้นที่ปฎิบัติงาน",
        },
        {
          Id: "",
          ChkId: "8",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "8. รถ เครื่องจัก และวัสดุอุปกรณ์ต้องวางห่างจากหลุมไม่น้อยกว่า 1 เมตร",
        },
        {
          Id: "",
          ChkId: "9",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "9. จัดให้มีระบบการถ่ายเทอากาศ และแสงสว่างที่เพียงพอและเหมาะสม",
        },
        {
          Id: "",
          ChkId: "10",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "10. กรณีในระหว่างปฎิบัติงาน หากพบเจอสายไฟ ท่อ ฯลฯ ให้หยุดปฎิบัติงาน และตรวจสอบพลังงาน / สสาร / สารเคมีคงค้าง พร้อมทบทวน JSA และจัดหามาตรการบรรเทา",
        },
        {
          Id: "",
          ChkId: "11",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "11. กรณีใช้ปั้นจั่น หรือเครื่องจักรหนัก ต้องจัดให้มี Sheet Pile โดยได้รับความเห็นชอบเป็นหนังสือจากวิศวกร และให้ปิดประกาศสำเนาหนังสือไว้ ณ ที่ก่อสร้าง",
        },
        {
          Id: "",
          ChkId: "12",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "12. กรณีต้องปฎิบัติงานกลางคืน ให้มีสัญญาณเตือนด้วยไฟกระพริบ/ไฟวับวาบแสงสีส้ม หรือป้ายสะท้อนแสง",
        },
        {
          Id: "",
          ChkId: "13",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "13. กรณีฝนตกให้มีการหยุดปฎิบัติงาน และหากต้องการเริ่มงานใหม่ให้กำหนดมาตรการอีกครั้ง",
        },
        {
          Id: "",
          ChkId: "14",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "14. กรณีใช้รถขุด จะต้องมีผู้ให้สัญญาณกับผู้บังคับรถขุดตลอดเวลา",
        },

        { ChecklistName: "2.3.2 กรณีงานขุดตั้งเเต่ 1.2 - 2 m." },
        {
          Id: "",
          ChkId: "15",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "15. จัดให้มีค้ำยัน หรือผนังเอียง 1.5 เท่าของความลึก หรือทำมุม 45 องศาโดยออกแบบให้เหมาะสมกับความลึกของหลุม ความแข็งของดิน",
        },
        {
          Id: "",
          ChkId: "16",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "16. ต้องให้มีการวัดแก๊สไวไฟ สารเคมีอันตราย ปริมาณออกซิเจน ก่อนเริ่มงาน และขณะทำงาน และให้พิจารณาปฎิบัติตามมาตรการงานอับอากาศตามความเสี่ยง",
        },
        {
          Id: "",
          ChkId: "17",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "17. ต้องจัดให้มีบันได ทางขึ้นลงแข็งแรง สะดวก และปลอดภัยทุกๆ ระยะ 20 เมตร",
        },

        { ChecklistName: "2.3.3 กรณีงานขุดตั้งเเต่ 2 m. ขึ้นไป" },
        {
          Id: "",
          ChkId: "18",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "18. ห้ามลงไปทำงานในรู หลุม บ่อ คู ที่มีขนาดน้อยกว่าหรือเท่ากับ 75 cm. ที่ความลึกตั้งเเต่ 2 เมตรขึ้นไป",
        },
        {
          Id: "",
          ChkId: "19",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "19. ต้องให้มีการวัดแก๊สไวไฟ สารเคมีอันตราย ปริมาณออกซิเจน ก่อนเริ่มงาน และขณะทำงาน และให้พิจารณาปฎิบัติตามมาตรการงานอับอากาศตามความเสี่ยง",
        },
        {
          Id: "",
          ChkId: "20",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "20. ต้องจัดให้มีบันได ทางขึ้นลงแข็งแรง สะดวก และปลอดภัยทุกๆ ระยะ 20 เมตร",
        },
        {
          Id: "",
          ChkId: "21",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "21. ผู้ควบคุมงานที่มีประสบการณ์ด้านงานดิน และผ่านการอบรมหลักสูตรการช่วยเหลือ และปฐมพยาบาล ประจำบริเวณปากรู หลุม บ่อ คู ที่มีการขุดเจาะ",
        },
        {
          Id: "",
          ChkId: "22",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "22. อุปกรณ์สื่อสาร หรือรับส่งสัญญาณในกรณีฉุกเฉินระหว่างผู้ควบคุมงานกับผู้ปฎิบัติงาน",
        },
        {
          Id: "",
          ChkId: "23",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "23. จัดให้มีอุปกรณ์การช่วยชีวิตกรณีเกิดเหตุฉุกเฉินตาม Rescue Plan ได้แก่ สายหรือเชือกช่วยชีวิตและเข็มขัดนิรภัยพร้อมอุปกรณ์ที่สามารถเกาะเกี่ยวได้เพื่อช่วยเหลือกรณีฉุกเฉิน",
        },
        {
          Id: "",
          ChkId: "24",
          Checklist: "",
          Comment: "",
          ChecklistName:
            "24. ต้องจัดให้มีการคำนวณ ออกแบบ และกำหนดขั้นตอนการดำเนินการโดยวิศวกร ต้องปฎิบัติตามแบบและขั้นตอน มาตรการป้องกัน การเคลื่อนตัวของดิน โดยวิศวกรก่อนลงมือปฎิบัติงาน",
        },
      ],
      checkInsertUpdate: "swc_checklist_insert",
      form: {
        [$f.Id]: "",
        [$f.DocumentCode]: "",
        [$f.DocumentNumber]: "SD-SF-F-0026",
        [$f.EffectDate]: "01/10/2021",
        [$f.RequesterEmpId]: "",
        [$f.RequesterName]: "",
        [$f.Department]: "",
        [$f.WorkDistrict]: "",
        [$f.WorkplaceAndEquipment]: "",
        [$f.MiningArea]: "",
        [$f.MiningReason]: "",
        [$f.MiningEquipment]: "",
        [$f.MiningDept]: "",
        [$f.MiningDeptValue]: "",
        [$f.MiningStartDate]: "",
        [$f.MiningStartTime]: "",
        [$f.MiningEndDate]: "",
        [$f.MiningEndTime]: "",
        [$f.ApprovedEE]: "",
        [$f.ApprovedME]: "",
        [$f.EEComment]: "",
        [$f.MEComment]: "",
        [$f.isUndergroundLine]: "",
        [$f.UndergroundLine]: "",
        [$f.isUndergroundLineDocument]: "",
        [$f.UndergroundLineDocument]: "",
        [$f.isGroundingSystem]: "",
        [$f.isLightingSystem]: "",
        [$f.isNetworkSystem]: "",
        [$f.isEEApproved]: "",
        [$f.EEApprovedDateTime]: "",
        [$f.isUndergroundPipe]: "",
        [$f.UndergroundPipe]: "",
        [$f.isUndergroundPipeDocument]: "",
        [$f.UndergroundPipeDocument]: "",
        [$f.isPipingArrangement]: "",
        [$f.isFireWater]: "",
        [$f.isPidOrFw]: "",
        [$f.isNearContructionCheck]: "",
        [$f.isMEApproved]: "",
        [$f.MEApprovedDateTime]: "",
        [$f.Step]: "",
        [$f.Status]: "",

        files1: [],
        Listfiles1: [],

        files2: [],
        Listfiles2: [],

        files1_EE: [],
        Listfiles1_EE: [],
        files2_EE: [],
        Listfiles2_EE: [],
        files3_EE: [],
        Listfiles3_EE: [],

        files1_ME: [],
        Listfiles1_ME: [],
        files2_ME: [],
        Listfiles2_ME: [],
        files3_ME: [],
        Listfiles3_ME: [],
        files4_ME: [],
        Listfiles4_ME: [],
      },
      modalDeviation: {
        area: "",
        deviationDoc: "",
        datalistResult: [],
        PageSize: 5,
        PageNo: 1,
        totalItem: 1,
        Size: [10, 20, 50, 100],
      },
      deviationData: [],
      deviationId: "",
      deviationSelected: [],
      flowStep: null,
    };
  },
  computed: {
    setLanguage() {
      return this.$store.state.language === 0 ? "title_th" : "title";
    },
    UserPropEmpID() {
      return this.$route.params.empid;
    },
    UserPropCompanyID() {
      return this.$route.params.companyid;
    },
    setReqWorkpermitID() {
      return this.$route.params.reqID;
    },
    setCertificationID() {
      return this.$route.params.cerID;
    },
    setCertificationType() {
      return "3";
    },
  },
  methods: {
    onGetByItem(ID) {
      this.$parent.loadingPage("show");

			Apiservice.onStep1_Get({
        SessionEmpID: this.UserPropEmpID,
        Module: "GetStepOneByItem",
				CompanyId: this.UserPropCompanyID,
        body: {
					Id: String(this.setReqWorkpermitID)
        }
      }, (res) => {
        if (res === null || res === "") {
          this.onAlert("onLoadform", "Error not found.", null); // title, msg, func
				}
        if (res.data.Status === true) {
					if (res.data.body.length !== 0) {
						const tmpData = res.data.body[0];

						if (HelpFunc.checkEmptyData(tmpData.PermitNo) === false) {
							this.dataheader.breadcrumb.push({
								title: "PTW No. " + tmpData.PermitNo,
								path: "",
							})
                            this.flowStep = tmpData.Step
						}
					}
        } else {
          this.onAlert("onLoadform", res.data.ErrorMessage, null); // title, msg, func
        }
      });

      Apiservice.onExcavation_Get(
        {
          SessionEmpID: this.UserPropEmpID,
          Module: "GetByItem",
          CompanyId: this.UserPropCompanyID,
          body: {
            Id: String(ID),
          },
          PageSize: 10,
          PageNo: 1,
        },
        (res) => {
          if (res === null || res === "")
            this.onAlert("Template : Statement", "Error not found.", null); // title, msg, func
          if (res.data.Status === true) {
            const tmp = res.data.body[0];
            // Set Value in form
            this.form = {
              [this.field.Id]: tmp[this.field.Id],
              [this.field.DocumentCode]: tmp[this.field.DocumentCode],
              [this.field.DocumentNumber]: tmp[this.field.DocumentNumber],
              [this.field.EffectDate]: tmp[this.field.EffectDate],
              [this.field.RequesterEmpId]: tmp[this.field.RequesterEmpId],
              [this.field.RequesterName]: tmp[this.field.RequesterName],
              [this.field.Department]: tmp[this.field.Department],
              [this.field.WorkDistrict]: tmp[this.field.WorkDistrict],
              [this.field.WorkplaceAndEquipment]:
                tmp[this.field.WorkplaceAndEquipment],
              [this.field.MiningArea]: tmp[this.field.MiningArea],
              [this.field.MiningReason]: tmp[this.field.MiningReason],
              [this.field.MiningEquipment]: tmp[this.field.MiningEquipment],
              [this.field.MiningDept]: tmp[this.field.MiningDept],
              [this.field.MiningDeptValue]:
                tmp[this.field.MiningDeptValue] == null
                  ? ""
                  : tmp[this.field.MiningDeptValue],
              [this.field.MiningStartDate]:
                tmp[this.field.MiningStartDate] == null
                  ? ""
                  : tmp[this.field.MiningStartDate]
                      .split("/")
                      .reverse()
                      .join("-"),
              [this.field.MiningStartTime]:
                tmp[this.field.MiningStartTime] == null
                  ? ""
                  : tmp[this.field.MiningStartTime],
              [this.field.MiningEndDate]:
                tmp[this.field.MiningEndDate] == null
                  ? ""
                  : tmp[this.field.MiningEndDate]
                      .split("/")
                      .reverse()
                      .join("-"),
              [this.field.MiningEndTime]:
                tmp[this.field.MiningEndTime] == null
                  ? ""
                  : tmp[this.field.MiningEndTime],
              [this.field.ApprovedEE]:
                tmp[this.field.ApprovedEE] == null
                  ? ""
                  : tmp[this.field.ApprovedEE],
              [this.field.EEEmpId]: tmp[this.field.EEEmpId],
              [this.field.ApprovedEEName]: tmp[this.field.ApprovedEEName],
              [this.field.ApprovedME]:
                tmp[this.field.ApprovedME] == null
                  ? ""
                  : tmp[this.field.ApprovedME],
              [this.field.MEEmpId]: tmp[this.field.MEEmpId],
              [this.field.ApprovedMEName]: tmp[this.field.ApprovedMEName],
              // Step 2 EE Approve
              [this.field.isUndergroundLine]:
                tmp[this.field.isUndergroundLine] == null
                  ? ""
                  : tmp[this.field.isUndergroundLine],
              [this.field.UndergroundLine]: tmp[this.field.UndergroundLine],
              [this.field.isUndergroundLineDocument]:
                tmp[this.field.isUndergroundLineDocument] == null
                  ? ""
                  : tmp[this.field.isUndergroundLineDocument],
              [this.field.UndergroundLineDocument]:
                tmp[this.field.UndergroundLineDocument],
              [this.field.isGroundingSystem]:
                tmp[this.field.isGroundingSystem] == null
                  ? ""
                  : tmp[this.field.isGroundingSystem],
              [this.field.isLightingSystem]:
                tmp[this.field.isLightingSystem] == null
                  ? ""
                  : tmp[this.field.isLightingSystem],
              [this.field.isNetworkSystem]:
                tmp[this.field.isNetworkSystem] == null
                  ? ""
                  : tmp[this.field.isNetworkSystem],
              [this.field.isEEApproved]:
                tmp[this.field.isEEApproved] == null
                  ? ""
                  : tmp[this.field.isEEApproved],
              [this.field.EEApprovedDateTime]:
                tmp[this.field.EEApprovedDateTime] == null
                  ? ""
                  : tmp[this.field.EEApprovedDateTime]
                      .split(" ")[0]
                      .split("/")
                      .join("-") +
                    " " +
                    tmp[this.field.EEApprovedDateTime].split(" ")[1],
              [this.field.EEComment]: tmp[this.field.EEComment],
              EEDateTime:
                tmp[this.field.EEApprovedDateTime] == null
                  ? ""
                  : tmp[this.field.EEApprovedDateTime]
                      .split(" ")[0]
                      .split("/")
                      .reverse()
                      .join("/") +
                    " " +
                    tmp[this.field.EEApprovedTime].split(":")[0] +
                    ":" +
                    tmp[this.field.EEApprovedTime].split(":")[1],
              // Step 3 ME Approve
              [this.field.isUndergroundPipe]:
                tmp[this.field.isUndergroundPipe] == null
                  ? ""
                  : tmp[this.field.isUndergroundPipe],
              [this.field.UndergroundPipe]: tmp[this.field.UndergroundPipe],
              [this.field.isUndergroundPipeDocument]:
                tmp[this.field.isUndergroundPipeDocument] == null
                  ? ""
                  : tmp[this.field.isUndergroundPipeDocument],
              [this.field.UndergroundPipeDocument]:
                tmp[this.field.UndergroundPipeDocument],
              [this.field.isPipingArrangement]:
                tmp[this.field.isPipingArrangement] == null
                  ? ""
                  : tmp[this.field.isPipingArrangement],
              [this.field.isFireWater]:
                tmp[this.field.isFireWater] == null
                  ? ""
                  : tmp[this.field.isFireWater],
              [this.field.isPidOrFw]:
                tmp[this.field.isPidOrFw] == null
                  ? ""
                  : tmp[this.field.isPidOrFw],
              [this.field.isNearContructionCheck]:
                tmp[this.field.isNearContructionCheck] == null
                  ? ""
                  : tmp[this.field.isNearContructionCheck],
              [this.field.isMEApproved]:
                tmp[this.field.isMEApproved] == null
                  ? ""
                  : tmp[this.field.isMEApproved],
              [this.field.MEApprovedDateTime]:
                tmp[this.field.MEApprovedDateTime] == null
                  ? ""
                  : tmp[this.field.MEApprovedDateTime]
                      .split(" ")[0]
                      .split("/")
                      .join("-") +
                    " " +
                    tmp[this.field.MEApprovedDateTime].split(" ")[1],
              [this.field.MEComment]: tmp[this.field.MEComment],
              MEDateTime:
                tmp[this.field.MEApprovedDateTime] == null
                  ? ""
                  : tmp[this.field.MEApprovedDateTime]
                      .split(" ")[0]
                      .split("/")
                      .reverse()
                      .join("/") +
                    " " +
                    tmp[this.field.MEApprovedTime].split(":")[0] +
                    ":" +
                    tmp[this.field.MEApprovedTime].split(":")[1],

              [this.field.Step]: tmp[this.field.Step],
              [this.field.Status]: tmp[this.field.Status],

              files1: [],
              Listfiles1: [],
              files2: [],
              Listfiles2: [],

              files1_EE: [],
              Listfiles1_EE: [],
              files2_EE: [],
              Listfiles2_EE: [],
              files3_EE: [],
              Listfiles3_EE: [],

              files1_ME: [],
              Listfiles1_ME: [],
              files2_ME: [],
              Listfiles2_ME: [],
              files3_ME: [],
              Listfiles3_ME: [],
              files4_ME: [],
              Listfiles4_ME: [],
            };
            for (let index = 0; index < tmp.sResFile.length; index++) {
              let OBJfile = tmp.sResFile[index];
              if (OBJfile.SeqID == "1") {
                this.form.Listfiles1.push(OBJfile);
              } else if (OBJfile.SeqID == "2") {
                this.form.Listfiles2.push(OBJfile);
              } else if (OBJfile.SeqID == "3") {
                this.form.Listfiles1_EE.push(OBJfile);
              } else if (OBJfile.SeqID == "4") {
                this.form.Listfiles2_EE.push(OBJfile);
              } else if (OBJfile.SeqID == "5") {
                this.form.Listfiles3_EE.push(OBJfile);
              } else if (OBJfile.SeqID == "6") {
                this.form.Listfiles1_ME.push(OBJfile);
              } else if (OBJfile.SeqID == "7") {
                this.form.Listfiles2_ME.push(OBJfile);
              } else if (OBJfile.SeqID == "8") {
                this.form.Listfiles3_ME.push(OBJfile);
              } else if (OBJfile.SeqID == "9") {
                this.form.Listfiles4_ME.push(OBJfile);
              }
            }
            this.onGetChecklist();
            this.onGetDeviation(this.setReqWorkpermitID);
            this.$parent.loadingPage("hide");
          } else {
            this.$parent.loadingPage("hide");
            this.onAlert("on Get by item", res.data.ErrorMessage, null); // title, msg, func
          }
        }
      );
    },
    onGetChecklist() {
      Apiservice.onStepSWC_Cer_Get(
        {
          SessionEmpID: this.UserPropEmpID,
          Module: "GetSWC_Checklist",
          CompanyId: this.UserPropCompanyID,
          body: {
            ReqId: this.setReqWorkpermitID,
            SwcId: this.setCertificationID,
            SwcType: this.setCertificationType,
          },
        },
        (res) => {
          if (res === null || res === "")
            this.onAlert("onStepSWC_Cer_Get", "Error not found.", null);
          if (res.data.Status === true) {
            if (res.data.body.length !== 0) {
              this.checkInsertUpdate = "swc_checklist_update";

              const tmpdataset = res.data.body;
              tmpdataset.forEach((item, index) => {
                if (item.ChkId == "0") {
                  this.deviationId = String(item.Id);
                  this.deviationSelected =
                    item.ChkDeviation === ""
                      ? []
                      : item.ChkDeviation.split(",");
                } else {
                  const indexCKlist = this.Section2_Table.findIndex(
                    (val) => val.ChkId === item.ChkId
                  );
                  this.Section2_Table[indexCKlist].Id = item.Id;
                  this.Section2_Table[indexCKlist].Checklist = item.Checklist;
                  this.Section2_Table[indexCKlist].Comment = item.Comment;
                }
              });
            }
          } else {
            this.onAlert("onStepSWC_Cer_Get", res.data.ErrorMessage, null);
          }
        }
      );
    },
    onGetDeviation(ID) {
      Apiservice.onStepSWC_Deviation_Get(
        {
          SessionEmpID: this.UserPropEmpID,
          Module: "",
          CompanyId: this.UserPropCompanyID,
          body: {
            ReqId: String(ID),
          },
        },
        (res) => {
          if (res === null || res === "") {
            this.onAlert("on_Deviation_Get", "Error not found.", null);
          } // title, msg, func
          if (res.data.Status === true) {
            if (res.data.body.length !== 0) {
              this.deviationData = res.data.body;
              this.paging.totalItem = res.data.body.totalrow;
            }
          }
        }
      );
    },
    onModelDeviation_search() {
      this.$parent.loadingPage("show");
      Apimaster.DeviatRequest(
        {
          SessionEmpID: this.UserPropEmpID,
          Module: "GetAll",
          CompanyId: this.UserPropCompanyID,
          body: {
            Id: "",
            TextSearch1: String(this.modalDeviation.area),
            TextSearch2: this.modalDeviation.deviationDoc,
            TextSearch3: "",
            TextSearch4: "",
            TextSearch5: "",
            TextSearch6: "",
            TextSearch7: "",
            TextSearch8: "",
            TextSearch9: "",
            TextSearch10: "",
            DateSearch1: "",
            DateSearch2: "",
          },
          PageSize: this.modalDeviation.PageSize,
          PageNo: this.modalDeviation.PageNo,
        },
        (res) => {
          if (res === null || res === "")
            this.onAlert("onSearch", "Error not found.", null); // title, msg, func
          if (res.data.Status === true) {
            if (res.data.body.length !== 0) {
              this.modalDeviation.datalistResult = res.data.body;
              this.modalDeviation.totalItem = Number(res.data.body[0].totalrow);
            }
          } else {
            this.onAlert("onSearch", res.data.ErrorMessage, null); // title, msg, func
          }
          this.$parent.loadingPage("hide");
        }
      );
    },
    onModelDeviation_select(val) {
      if (this.deviationSelected.indexOf(val) === -1) {
        this.deviationSelected.push(val);
      } else {
        const indexSelect = this.deviationSelected.indexOf(val);
        if (indexSelect !== -1) {
          this.deviationSelected.splice(indexSelect, 1);
        }
      }
    },
    onModelDeviationMain_select(val) {
      if (this.modalDeviation.selected.indexOf(val) === -1) {
        this.modalDeviation.selected.push(val);
      } else {
        const indexSelect = this.modalDeviation.selected.indexOf(val);
        if (indexSelect !== -1) {
          this.modalDeviation.selected.splice(indexSelect, 1);
        }
      }
    },
    onModelDeviation_add() {
      const tempdata = this.modalDeviation.selected;
      Apiservice.onStepSWC_Deviation_InsertUpdate(
        {
          SessionEmpID: this.UserPropEmpID,
          Module: "deviation_update",
          CompanyId: this.UserPropCompanyID,
          body: {
            ReqId: this.setReqWorkpermitID,
            DeviationId: tempdata.length === 0 ? "" : tempdata.join(","),
          },
        },
        (res) => {
          if (res === null || res === "") {
            this.onAlert(
              "onStepSWC_Deviation_InsertUpdate",
              "Error not found.",
              null
            );
          } // title, msg, func
          if (res.data.Status === true) {
            this.onGetDeviation();
            this.$refs["modal-AddDeviation"].hide();
          } else {
            this.onAlert(
              "onStepSWC_Deviation_InsertUpdate",
              res.data.ErrorMessage,
              null
            ); // title, msg, func
            this.onGetDeviation();
            this.$refs["modal-AddDeviation"].hide();
          }
        }
      );
    },
    onModelDeviation_checked(val) {
      return this.deviationSelected.indexOf(val) !== -1;
    },
    onModelDeviation_clear() {
      this.modalDeviation.area = "";
      this.modalDeviation.deviationDoc = "";
      this.modalDeviation.selected = [];
      this.onModelDeviation_search();
    },
    onClickAddDeviation() {
      (this.modalDeviation = {
        selected: [],
        area: "",
        deviationDoc: "",
        datalistResult: [],
        PageSize: 5,
        PageNo: 1,
        totalItem: 1,
      }),
        this.$refs["modal-AddDeviation"].show();
      this.onModelDeviation_search();
      this.deviationData.forEach((item) => {
        this.modalDeviation.selected.push(item.Id);
      });
    },
    onClickAdd_inputModal() {
      const tempdata = this.modalDeviation.selected;

      Apiservice.onStepSWC_Deviation_InsertUpdate(
        {
          SessionEmpID: this.UserPropEmpID,
          Module: "deviation_update",
          CompanyId: this.UserPropCompanyID,
          body: {
            ReqId: this.setReqWorkpermitID,
            DeviationId: tempdata.length === 0 ? "" : tempdata.join(","),
          },
        },
        (res) => {
          if (res === null || res === "") {
            this.onAlert(
              "onStepSWC_Deviation_InsertUpdate",
              "Error not found.",
              null
            ); // title, msg, func
          }
          if (res.data.Status === true) {
            this.onGetDeviation(this.setReqWorkpermitID);
            this.$refs["modal-AddDeviation"].hide();
          } else {
            this.onAlert(
              "onStepSWC_Deviation_InsertUpdate",
              res.data.ErrorMessage,
              null
            ); // title, msg, func
            this.onGetDeviation(this.setReqWorkpermitID);
            this.$refs["modal-AddDeviation"].hide();
          }
        }
      );
    },
    onClickCancel_inputModal() {
      this.$refs["modal-AddDeviation"].hide();
    },
    onModelDeviation_ChangeCurrentPage(e) {
      this.modalDeviation.PageNo = e;
      this.onModelDeviation_search();
    },
    onModelDeviation_ChangePageSize(e) {
      this.modalDeviation.PageNo = 1;
      this.onModelDeviation_search();
    },
    onClickNext() {
      this.onModelCertificate_update();
    },
    onChangeCurrentPage(e) {
      this.paging.PageNo = e;
      this.Search();
    },
    onChangePageSize(e) {
      this.paging.PageNo = 1;
      this.Search();
    },
    onValidation() {
      let msg = "";
      const getTitle = (val)=> {
        if (HelpFunc.checkEmptyData(val) !== true) {
          const h = val.split(" ");
          return " ข้อที่ " + h[0]
        } else {
          return ''
        }
      }
      
      this.Section2_Table.forEach((item, index) => {
        if (HelpFunc.checkEmptyData(item.ChkId) !== true) {
          if (item.Checklist == 2 && HelpFunc.checkEmptyData(item.Comment) === true && msg === '') {
            msg = "กรุณาระบุ เหตุผลไม่ผ่านการตรวจสอบ" + getTitle(item.ChecklistName);
          }
          if (HelpFunc.checkEmptyData(item.Checklist) === true && msg === '') {
            msg = "กรุณาเลือก ผลการตรวจสอบ" + getTitle(item.ChecklistName);
          }
        }
      });
      return msg;
    },
    onSetdata() {
      let databody = {
        ReqId: this.setReqWorkpermitID,
        sOnFieldSWC: [],
        sOnFieldSWC_selectFlag: [],
        sWorkerNameSWC: [],
      };
      databody.sOnFieldSWC.push({
        Id: this.deviationId,
        ReqId: this.setReqWorkpermitID,
        SWCId: this.setCertificationID,
        SwcType: this.setCertificationType,
        ChkId: "0",
        Checklist: "",
        Comment: "",
        ChkDeviation:
          this.deviationSelected.length === 0
            ? ""
            : this.deviationSelected.join(","),
      });
      this.Section2_Table.forEach((item) => {
        if (HelpFunc.checkEmptyData(item.ChkId) !== true) {
          databody.sOnFieldSWC.push({
            Id: item.Id,
            ReqId: this.setReqWorkpermitID,
            SWCId: this.setCertificationID,
            SwcType: this.setCertificationType,
            ChkId: item.ChkId,
            Checklist: item.Checklist,
            Comment: item.Comment,
            ChkDeviation: "",
          });
        }
      });
      return databody;
    },
    onModelCertificate_update() {
      const msg = this.onValidation();
      if (msg !== "") {
        this.onAlert("Notification", msg, null); // title, msg, func
        return false;
      } else {
        this.$parent.loadingPage("show");
        
        Apiservice.onStepSWC_Cer_InsertUpdate(
          {
            SessionEmpID: this.UserPropEmpID,
            Module: this.checkInsertUpdate,
            CompanyId: this.UserPropCompanyID,
            body: this.onSetdata(),
          },
          (res) => {
            this.$parent.loadingPage("hide");
            if (res === null || res === "")
              this.onAlert(
                "onStepSWC_Cer_InsertUpdate",
                "Error not found.",
                null
              );
            if (res.data.Status === true) {
              location.reload();
            } else {
              this.onAlert(
                "onStepSWC_Cer_InsertUpdate",
                res.data.ErrorMessage,
                null
              );
            }
          }
        );
      }
    },
    //Function gen data file
    genData(data) {
      const type = HelpFunc.checkTypeforloadFiles(data.FileName.split('.').pop())
      const linkSource = 'data:'+type+';base64,'+data.PathPdf;
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      downloadLink.href = linkSource;
      downloadLink.target = "_self";
      downloadLink.download = data.FileName;
      downloadLink.click();
    },
    onAlert(title, msg, func) {
      this.$parent.alertMsgBox(title, msg, func); // title, msg, func
    },
    onCheckPermissionPage() {
      HelpFunc.checkPermissionForPage(
        this.setReqWorkpermitID,
        this.UserPropEmpID,
        (val) => {
            this.permissionAction = this.flowStep > 13 ? false : val;
        }
      ); //ReqId, EmpId, Callback
    },
		getToken(Username, callback) {
      Apiservice.onToken({
				Username: Username
      }, (response) => {
        if (response.data.Status == true) {
					if (response === null || response === "") {
						this.onAlert("Message", "Error user not found.", null); // title, msg, func
					} else {
						if (response.data.Token === null || response.data.Token === "") {
							this.onAlert("Message", "Error user not found.", null); // title, msg, func
						} else {
							callback(response.data.Token)
						} 
					}
        } else {
          this.onAlert("Message", response.data.ErrorMessage, null); // title, msg, func
        }
      });
		},
  },
  created() {
    this.getToken(this.$route.params.username, (token)=> {
      this.$store.dispatch('token', token);
      
      checkCompanyAPI.checkCompanyByValue(this.UserPropCompanyID, (CompamyCheck)=> {
        if (HelpFunc.checkEmptyData(CompamyCheck.Message) === false) {
          this.onAlert("Message", CompamyCheck.Message, null); // title, msg, func
        } else {
          this.onGetByItem(this.setCertificationID);
          this.onCheckPermissionPage();
        }
      })
    })
  },
  mounted() {
    this.$nextTick(function () {});
  },
};
</script>
<style scoped>
.text-suffix {
  position: absolute;
  top: 40px;
  right: 15px;
}
h3.back-color {
  padding: 0.5rem 10px;
  background-color: #e4e7ea;
  border-radius: 0.6rem;
}
div.underline {
  border-bottom: 0.5px solid rgba(168, 168, 168, 0.425);
}
.form-check-input[type="checkbox"].cus-ck-size {
  height: 46px;
  width: 46px;
  border-radius: 0.8rem;
}
.btn .svg-inline--fa.cus-i-size {
  height: 46px !important;
  width: 46px !important;
  padding: 0;
}
</style>